import React, { useState, useEffect } from "react";
import { useGoldControlMutation } from "../store/api";

declare global {
    interface Window {
        gapi: any;
    }
}

export const AdminGoldControl: React.FC = () => {
    const [isApiLoaded, setIsApiLoaded] = useState(false);
    const [videoId, setVideoId] = useState("M2JIYm1iVoY");
    const [userIds, setUserIds] = useState<number[]>([]);
    const [idsText, setIdsText] = useState("");
    const [pageToken, setPageToken] = useState<string | null>(null);
    const [loadCount, setLoadCount] = useState(1);

    // Мутация контроля
    const [control, { isLoading: isControlling }] = useGoldControlMutation();

    useEffect(() => {
        // Загружаем YouTube API скрипт
        const script = document.createElement("script");
        script.src = "https://apis.google.com/js/api.js";
        script.onload = () => {
            console.log("YouTube API script loaded");
        };
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const loadClient = () => {
        if (!window.gapi) {
            alert("YouTube API не загружен");
            return;
        }

        window.gapi.client
            .setApiKey("AIzaSyDWpZa0lf7uKMevlg1d-w2vGENkC1ny0Vg")
            .then(() => {
                return window.gapi.client.load(
                    "https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest"
                );
            })
            .then(() => {
                console.log("GAPI client loaded for API");
                setIsApiLoaded(true);
            })
            .catch((err: any) => {
                console.error("Error loading GAPI client for API", err);
                alert("Ошибка загрузки API: " + err.message);
            });
    };

    const execute = (token?: string) => {
        if (
            !window.gapi ||
            !window.gapi.client ||
            !window.gapi.client.youtube
        ) {
            alert("YouTube API не готов");
            return;
        }

        const params: any = {
            part: ["snippet", "id", "replies"],
            maxResults: 1000,
            videoId: videoId,
        };

        if (token) {
            params.pageToken = token;
        }

        window.gapi.client.youtube.commentThreads
            .list(params)
            .then((response: any) => {
                console.log("Response", response);

                const newIds: number[] = [];
                response.result.items.forEach((item: any) => {
                    const str =
                        item.snippet.topLevelComment.snippet.textDisplay;
                    const parts = str.split("|");
                    let theId = parseInt(parts[1]);

                    if (!isNaN(theId)) {
                        newIds.push(theId);
                    } else {
                        theId = parseInt(str.replace(/[^\d]/g, ""));
                        if (!isNaN(theId)) {
                            newIds.push(theId);
                        }
                    }
                });

                setUserIds((prev) => [...prev, ...newIds]);
                setIdsText(
                    (prev) => (prev ? prev + "," : "") + newIds.join(",")
                );

                if (response.result.nextPageToken) {
                    setPageToken(response.result.nextPageToken);
                    setLoadCount((c) => c + 1);
                } else {
                    setPageToken(null);
                }
            })
            .catch((err: any) => {
                console.error("Execute error", err);
                alert("Ошибка выполнения: " + err.message);
            });
    };

    const handleSubmit = async () => {
        if (!idsText.trim()) {
            alert("Введите ID пользователей");
            return;
        }

        try {
            const result = await control({ gold_control: idsText }).unwrap();
            alert(
                `Контроль выполнен. Удалено из Gold 1000: ${
                    result.removed_count || 0
                }`
            );
            setIdsText("");
            setUserIds([]);
        } catch (error: any) {
            alert("Ошибка: " + (error.data?.message || error.message));
        }
    };

    return (
        <div className="p-6 space-y-6">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                Контроль Gold 1000
            </h1>

            {/* YouTube API */}
            <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
                <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                    Загрузка комментариев из YouTube
                </h2>

                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Video ID
                        </label>
                        <input
                            type="text"
                            value={videoId}
                            onChange={(e) => setVideoId(e.target.value)}
                            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="Video ID"
                        />
                    </div>

                    <div className="flex gap-4">
                        {!isApiLoaded && (
                            <button
                                onClick={() => {
                                    window.gapi?.load("client", loadClient);
                                }}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md"
                            >
                                Load API
                            </button>
                        )}

                        {isApiLoaded && (
                            <>
                                <button
                                    onClick={() => execute()}
                                    className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md"
                                >
                                    Execute {loadCount > 1 && `(${loadCount})`}
                                </button>

                                {pageToken && (
                                    <button
                                        onClick={() => execute(pageToken)}
                                        className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-md"
                                    >
                                        Next Page {loadCount + 1}
                                    </button>
                                )}
                            </>
                        )}
                    </div>

                    {userIds.length > 0 && (
                        <div className="bg-gray-50 dark:bg-gray-900 p-4 rounded-md">
                            <div className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                                Найдено ID: {userIds.length}
                            </div>
                            <div className="text-xs text-gray-500 dark:text-gray-500 font-mono break-all">
                                {userIds.slice(0, 20).join(", ")}
                                {userIds.length > 20 &&
                                    ` ... (ещё ${userIds.length - 20})`}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Форма контроля */}
            <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
                <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                    Контроль посещений и лайков
                </h2>

                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            ID пользователей (через запятую):
                        </label>
                        <textarea
                            value={idsText}
                            onChange={(e) => setIdsText(e.target.value)}
                            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white font-mono"
                            rows={10}
                            placeholder="1,2,3,4,5..."
                        />
                    </div>

                    <button
                        onClick={handleSubmit}
                        disabled={isControlling}
                        className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-md disabled:opacity-50"
                    >
                        {isControlling ? "Выполнение..." : "Выполнить контроль"}
                    </button>

                    <div className="text-sm text-gray-600 dark:text-gray-400">
                        <p>
                            <strong>Внимание:</strong> Пользователи, которые НЕ
                            в списке, получат +1 к gold_miss. При gold_miss
                            &gt;= 5 пользователь будет удалён из Gold 1000.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
